import React, { forwardRef } from 'react';
import { Button } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';
import Messages from 'i18n/messages/common';

const FormDeleteButton = forwardRef((props, ref) => {
  const { text, style, icon, ...restProps } = props;
  return (
    <Button
      type='danger'
      style={{ borderRadius: '4px', ...(style || {}) }}
      icon={icon || <DeleteOutlined />}
      {...restProps}
      ref={ref}
    >
      {text === null ? null : (
        <span>{text || <FormattedMessage {...Messages.deleteBtn} />}</span>
      )}
    </Button>
  );
});

export default FormDeleteButton;
